<template>            
        <v-layout row wrap>            
            <v-flex >
                <v-card class="elevation-0">
                    <!--TODO:  Separa toolbar a otro componente-->
                    <!--v-toolbar 
                    v-if="$store.state.usuario.type == 'CLIENTE'"
                    dense 
                    flat 
                    color="blue" 
                    class="noborderradius" 
                    dark>                    

                    <v-toolbar-title>Pedido</v-toolbar-title>

                    <v-spacer></v-spacer>
                   
                    </v-toolbar-->
                    <v-data-iterator
                        :items="groupedLines"
                        class="elevation-1"
                        rows-per-page-text="Productos por página"
                        :rows-per-page-items="rowsperpageitems"                          
                        @update:pagination="$vuetify.goTo(0)"
                        :pagination.sync="pagination"    
                    >
                        <template v-slot:item="props">
                        <v-card class="elevation-1 mb-1 mt-1">
                            <v-layout wrap row>
                                <v-flex xs8>
                                    <v-card-title dense class="cardTitleGrid bold-text">{{props.item.Description}} </v-card-title>
                                    <div class="subtitleGrid" v-if="props.item.Alias != props.item.Description"><span class="itemAlias">{{ props.item.Alias }}</span></div>
                                    <div class="subtitleGrid" ><span class="itemIdCard">{{ props.item.No }}</span></div>
                                    <div class="subtitleGrid" v-if="$store.state.appconfig.autoventa || ($store.state.tipoDocumento == 'abono')">
                                        <span class="itemIdCard">{{ props.item.lotesCaption }}</span>
                                    </div>
                                    <v-layout wrap row>
                                        <v-flex xs3>
                                            <v-icon
                                                medium
                                                class="ml-2"
                                                @click="editItem(props.item)"
                                            >
                                                edit
                                            </v-icon>
                                        </v-flex>
                                        <v-flex xs3>
                                            <v-icon
                                                medium
                                                @click="deleteItem(props.item)"
                                            >
                                                delete
                                            </v-icon>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs4>
                                    <v-card-title dense class="cardTitleGrid bold-text">{{props.item.cantidad}} {{ props.item.uom }} </v-card-title>
                                    <div class="subtitleGrid" v-if="parseFloat(props.item.descuento) != 0"><span class="itemIdCard">- {{ parseFloat(props.item.descuento).toFixed(2) }} %</span> </div>
                                    <div class="subtitleGrid"><span class="itemIdCard">{{ parseFloat(props.item.precio).toFixed(2) }} €/udm </span></div>
                                    <div class="subtitleGrid" v-if="$store.state.appconfig.showVAT"><span  class="itemIdCard">IGIC: {{ props.item.prodPostingGroup }} %</span></div>
                                    <div class="subtitleGrid" v-if="$store.state.tipoDocumento != 'abono'" ><span class="itemIdCard bold-text">{{ totalImporteLinea(props.item,false,$store.state.appconfig.showVAT) }} €</span></div>
                                    <div class="subtitleGrid" v-else ><span class="itemIdCard bold-text">{{ totalImporteLinea(props.item,true,$store.state.appconfig.showVAT) }} €</span></div>
                                </v-flex>   
                            </v-layout>
                            <br>
                        </v-card>
                        </template>
                        <template v-slot:no-data>
                            <v-alert :value="true" color="error" icon="warning">
                                Añada productos en la pestaña 'Catálogo'
                            </v-alert>
                        </template>
                    </v-data-iterator>
                    <!--TODO: Separar en componentes totales y botonera-->
                    <v-list two-line style="padding: 0px;">                                                                                                                                         
                        <v-subheader>Totales</v-subheader>
                        <v-list-tile>                                                
                            <v-list-tile-content class="totalesContent">   
                                <v-layout
                                v-if="showCustDiscount()"
                                 row caption>
                                    Descuento Cliente: {{ custDiscount() }}%
                                </v-layout>   
                                <v-layout row caption>
                                    Descuentos: {{totalDescuentoPedido}}
                                </v-layout>   
                                <v-layout 
                                v-if="$store.state.appconfig.showVAT"
                                row caption>
                                    IGIC: {{totalImpuestoPedido}}
                                </v-layout>  
                                <v-layout row>
                                    TOTAL:&nbsp;<span class="font-weight-bold">{{totalImportePedido}}</span>
                                </v-layout>  
                            </v-list-tile-content>
                        </v-list-tile>
                       
                    </v-list>    
                    <v-container grid-list-md pt-0>  
                        <v-layout wrap>  
                            <v-flex xs12>
                            <v-select
                                v-if="($store.state.tipoDocumento != 'abono') && ($store.state.customers[$store.state.selectedCustIndex].addresses.length > 0)"
                                :items="shipToAddresses"
                                item-text="address"
                                item-value="code"
                                label="Dirección de envío"
                                v-model="shipToAddress"
                            ></v-select>
                            </v-flex>
                            <v-flex xs12>
                            <v-text-field
                                v-if="($store.state.tipoDocumento != 'abono')"
                                label="Mensaje al repartidor"
                                v-model="notaRepartidor"
                            ></v-text-field> 
                            </v-flex>
                            <v-flex xs12>
                            <v-expansion-panel v-model="panelIndex" class="notasPanel" >
                                <v-expansion-panel-content class="secondary textwhite">
                                    <template v-slot:header>
                                        <div class="titleNotas white--text">NOTA</div>
                                    </template>
                                    <v-layout row style="background-color: white">
                                        <v-textarea
                                            name="nota"
                                            filled
                                            auto-grow
                                            value=""
                                            v-model="notaPedido"
                                        ></v-textarea>
                                    </v-layout>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            </v-flex>
                            <v-flex xs12>
                                <v-btn 
                                color="error darken-2" 
                                href="" 
                                target="_blank"
                                block
                                @click="resetOrderItems()"
                                > 
                                    Borrar pedido
                                    <v-icon right dark>delete</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12>
                                <v-btn 
                                color="primary darken-2" 
                                :loading="loading"
                                :disabled="loading || (listitems.length == 0)"
                                class="white--text"
                                block
                                @click="creaPedido(false)"
                                > 
                                    Crear Pedido
                                    <v-icon right dark>cloud_upload</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12>
                                <v-btn 
                                v-if="($store.state.usuario.type == 'COMERCIAL') && ($store.state.tipoDocumento == 'autoventa') && ($store.state.customers[$store.state.selectedCustIndex].CombineShipments == 'No')"
                                color="primary darken-2" 
                                :loading="loading"
                                :disabled="loading || (listitems.length == 0)"
                                class="white--text"
                                block
                                @click="creaPedido(true)"
                                > 
                                    Crear Pedido y cobrar
                                    <v-icon right dark>cloud_upload</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12>
                                <v-btn 
                                v-if="($store.state.usuario.type == 'CLIENTE')"
                                color="warning" 
                                :loading="loading"
                                :disabled="loading || (listitems.length == 0)"
                                class="white--text"
                                block
                                @click="guardaPedido()"
                                > 
                                    Guardar Pedido
                                    <v-icon right dark>save</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        
                    </v-container>
                </v-card>
            </v-flex>
            <!--TODO Llevar el dialog a otro componente-->
            <v-dialog v-model="dialogEditPedido" >                
                <v-card>
                <v-card-title 
                class="grey lighten-2"
                primary-title>
                <div>
                    {{this.editedItemPedido.Description}}    <br> 
                    <span class="grey--text">{{this.editedItemPedido.No}}</span> <br>
                    <div v-if="editedItemPedido.PVPR" style="display: inline-flex "><span class="grey--text bold-text">PVPR - {{editedItemPedido.PVPR}}€ &nbsp;&nbsp;&nbsp;</span></div>
                    <div v-if="editedItemPedido.PVPRM" style="display: inline-flex "><span class="grey--text bold-text">PVPMR - {{editedItemPedido.PVPRM}}€</span></div>
                </div>
                </v-card-title>
                
                <v-card-text>
                    <v-container grid-list-md pa-0>
                    <ul>
                        <li v-for="error in errors" :key="error.id">
                            <v-alert :value="true" color="error" icon="warning"> {{ error.msg }}
                            </v-alert>      
                        </li>                  
                    </ul>
                    <v-layout wrap>
                        <v-flex xs6 sm4 md3>
                            <v-text-field v-model="editedItemPedido.cantidad" type="number" label="Cantidad" @focus="$event.target.select()" v-validate="'min_value:0'" name="cantidad"></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 v-if="$store.state.appconfig.allowUOMS" fluid>
                            <v-select
                            :items="editedItemPedido.uoms"
                            item-text="code"
                            item-value="code"
                            label="UD"
                            v-model="editedItemPedido.uom"
                            ></v-select>
                        </v-flex>  
                        <v-flex xs6 sm4 md3 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="editedItemPedido.precio" type="number" label="Precio" @focus="$event.target.select()" @change="editedItemPedido.precioEditado = true" v-validate="'min_value:0'" name="precio"></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="editedItemPedido.descuento" type="number" label="Descuento" @focus="$event.target.select()" v-validate="'max_value:100|min_value:0'" name="dto"></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm4 md3
                        v-if="editedItemPedido.trackingEnabled && ($store.state.tipoDocumento != 'abono')">
                            <v-select
                                :items="editedItemPedido.lotes"
                                :item-text="loteCaption"
                                item-value="lote"
                                label="Lote"
                                v-model="editedItemPedido.lote"
                            ></v-select>
                        </v-flex>
                        <v-flex xs6 sm2 md2
                        v-if="$store.state.tipoDocumento == 'abono'" >
                            <v-autocomplete
                                :items="editedItemPedido.lotes"
                                item-text="lote"
                                item-value="lote"
                                label="Lote"
                                v-model="editedItemPedido.lote"
                            ></v-autocomplete>
                        </v-flex>  
                    </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary darken-1" flat @click="close">Cancelar</v-btn>
                    <v-btn color="primary darken-1" flat @click="save">Guardar</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
            <dialogEditItemMobile >
            </dialogEditItemMobile>
        </v-layout>            
</template>
<script>
//import mixin from '@/components/mixin.js'
export default {
    //mixins:[mixin],
    name: 'pedidoMobile',
    
    data: () => ({
        loader: null,
        //loading: false,
        nota: '',
        date: new Date().toISOString().substr(0, 10),      
        menu: false,       
        valid: true,            
        select: null,        
        //rowsperpageitems: [5,10,25,{"text":"Todos","value":-1}],
        rowsperpageitems: [-1],
        pagination: {
            rowsPerPage: 20
        }, 
        headers: [
            {
            text: 'Código',
            align: 'left',
            sortable: false,
            value: 'code'
            },
            { text: 'Descripción', value: 'description' },
            { text: 'Cantidad', value: 'quantity' },
            { text: 'UD', value: 'uom' },
            { text: 'Lote', value: 'lote' },
            { text: 'Precio', value: 'price' },
            { text: 'Descuento', value: 'discount' },            
            { text: '% IGIC', value: 'prodPostingGroup' },
            { text: 'Total', value: 'total' },
            { text: 'Acciones', value: 'name', sortable: false }
        ],
        editedIndexPedido: -1,
        editedItemPedido: {
            cantidad: 0
        },
        dialogEditPedido: false,
        invCustDiscount: 0,
        groupedLines: [],
        panelIndex: -1,
        shipToAddress: ''
    }),
    methods: {
        guardaPedido(){
            this.$store.commit("startLoading");
            this.saveOrder();
        },
        custDiscount(){
            var total = this.totalImportePedidoMain(false);
            var discounts = [];
            var dto = 0;
            try{
                if (this.$store.state.usuario.type == 'CLIENTE'){                
                    discounts = this.$store.state.usuario.invoiceDisc;
                } else {
                    discounts = this.$store.state.customers[this.$store.state.selectedCustIndex].discounts;                
                }            
                for (var i = 0; i < discounts.length; i++){
                    //Estan ordenados de mayor a menor, se recorre el array
                    if (discounts[i].minAmount <= Math.abs(total)) dto = discounts[i].discount;
                }
            } catch (e){

            }
            return dto;
        },
        showCustDiscount(){
            if (this.$store.state.usuario.type == 'CLIENTE'){
                if (this.$store.state.usuario.invoiceDisc.length != 0)
                    return true                
            } else {
                if ((this.$store.state.selectedCustIndex != -1) && (this.$store.state.customers[this.$store.state.selectedCustIndex].discounts.length != 0)){
                    return true;
                }
            }
            return false;
        },
        loteCaption(item){
            if(item.caducidad != ''){
                return item.lote + '(' + item.disponible + ') - ' + item.caducidad;
            } else {                
                return item.lote + '(' + item.disponible + ')';
            }            
        }, 
        gotoSearch(){
            this.$router.push('menu');
        },           
        resetOrderItems(){
            this.setGlobalConfirmDialog('Confirmación','¿Desea borrar el pedido?',true);
            //this.$store.commit("resetOrderItems");
            //this.navigate(1);
        },
        creaPedido(cobrar){
            //this.loading = !this.loading;
            this.$store.commit("startLoading");
            this.listitems = this.groupedLines;
            this.createOrder(cobrar,this.shipToAddress);
        },
        editItem (item) {        
            //Dependiendo de si es abono o pedido, abriremos un dialog de edición u otro. Esto viene de la posibilidad de que haya lineas agrupadas con varios lotes en el abono.
            if (this.$store.state.tipoDocumento != 'abono'){
                var toEdit = this.listitems.filter(itm => (itm.No == item.No) && (itm.uom == item.uom) && (itm.precio == item.precio) && (itm.descuento == item.descuento));
                this.editedIndexPedido = this.listitems.indexOf(toEdit[0]);
                this.editedItemPedido = Object.assign({}, toEdit[0]);
                this.editedItemPedido.cantidad = item.cantidad;
                this.dialogEditPedido = true
            } else {
                this.$store.state.filter = item.No;
                this.getItems(true);
            }
        },
        deleteItem (item) {
            var toDelete = this.listitems.filter(itm => (itm.No == item.No) && (itm.uom == item.uom) && (itm.precio == item.precio) && (itm.descuento == item.descuento));
            confirm('¿Desea eliminar el producto?') && toDelete.forEach(delitm => {
                const index = this.listitems.indexOf(delitm);
                this.listitems.splice(index, 1);
            });
            //confirm('¿Desea eliminar el producto?') && this.listitems.splice(index, 1)
        },
        close () {
            this.dialog = false;
            this.dialogEditPedido = false;
        },
        save () {    
            this.$validator.validate().then(valid => {
                if (!valid) {
                    ok = false;
                } else {                    
                    if (this.editedItemPedido.trackingEnabled){
                        var ok = true;
                        if (!this.editedItemPedido.lote) ok = false;                
                        if (!ok){
                            this.setGlobalDialog('Lote requerido','Uno o mas de los productos que ha introducido carecen de lote. Revise los datos.',false);
                            return;
                        } else {
                            var resLote = this.editedItemPedido.lotes.find(itm =>{
                                return itm.lote == this.editedItemPedido.lote;
                            });
                            if (resLote.length == undefined) resLote = [resLote];
                            var orderQty = 0;
                            //Control de cantidad en otras lineas en pedido   
                            //Revisar e intentar hacerlo igual que en la lista catalogo, que la variable que se le pasa
                            //al edit item sea una shallow copy de orderItems            
                            /*var res = this.listitems.filter(itm =>{
                                return (itm.lote == this.editedItem.lote) && (itm.No == this.editedItem.No);
                            });        
                            if (res != undefined) {
                                if (res.length == undefined) res = [res];            
                                for (var j = 0; j < res.length; j++){
                                    orderQty += parseFloat(res[j].cantidad);
                                }
                            }
                            if (parseFloat(resLote[0].disponible) < orderQty){
                                this.setGlobalDialog('Exceso de cantidad', 'Se ha introducido mayor cantidad (' + orderQty + ') que la disponible para el lote ' + this.editedItem.lote + ' (' + resLote[0].disponible + ')',false);
                                return;
                            }        
                            if ((this.editedItem.precio == 0) && (this.editedItem.descuento != 100)){
                                this.setGlobalDialog('Línea sin precio', 'No se ha introducido precio para el producto ' + this.editedItem.No ,false);
                                return;
                            }     */   
                        }
                    }  
                    var item =  this.editedItemPedido;
                    var res = this.editedItemPedido.uoms.filter(uom => {
                        return uom.code == item.uom;
                    });
                    if (res.length){
                        this.editedItemPedido.qtyperuom = parseFloat(res[0].qty_per_uom);
                    }
                    Object.assign(this.listitems[this.editedIndexPedido], this.editedItemPedido)
                    this.close();
                    this.groupLines();
                }
            });            
        },
        totalImportePedidoMain(calcVAT){
            /*var total = 0;
            var dto = 0;
            var igic = 0;
            var dto_cliente = 0;
            //%Descuento cliente
            if (calcVAT){                
                dto_cliente = this.custDiscount();
            }
            for (var i = 0; i < this.listitems.length; i++){
                if (this.listitems[i].item){
                    var lineAmount = parseFloat((this.listitems[i].precio * this.listitems[i].cantidad * this.listitems[i].qtyperuom).toFixed(2));
                    var dto_linea = parseFloat((this.listitems[i].descuento/100 * lineAmount).toFixed(2));
                    dto += dto_linea;                    
                    total += lineAmount;
                    if (calcVAT){
                        var lineAmountforVAT = lineAmount - dto_linea;
                        lineAmountforVAT -= parseFloat(dto_cliente/100*lineAmountforVAT);
                        var igic_linea = parseFloat((this.listitems[i].prodPostingGroup/100 * lineAmountforVAT).toFixed(3));                    
                        igic_linea = parseFloat(igic_linea.toFixed(2));                                            
                        igic += igic_linea;
                        igic = parseFloat(igic.toFixed(3));
                    }
                }
            }
            dto += parseFloat((dto_cliente/100 * (total - dto)).toFixed(2));
                        
            //Se aplcia redondeo al desceunto para que cuadre con NAV
            if (this.$store.state.tipoDocumento != 'abono')
                if (this.$store.state.appconfig.showVAT)
                    return (total-dto+igic);    
                else
                    return (total-dto);
            else 
                if (this.$store.state.appconfig.showVAT)
                    return ((total-dto+igic) * -1);    
                else 
                    return ((total-dto) * -1);
            */
            var total_vat = 0;
            var total_novat = 0;
            for (var i = 0; i < this.listitems.length; i++){
                total_vat += Number(this.totalImporteLinea(this.listitems[i],this.$store.state.tipoDocumento == 'abono',calcVAT));
                total_novat += Number(this.totalImporteLinea(this.listitems[i],this.$store.state.tipoDocumento == 'abono',false));
            }
            /*//console.log(calcVAT);
            //console.log("Total con imp: " + total_vat);
            //console.log("Total sin imp: " + total_novat);
            //console.log("Total vat: " + this.decimalAdjust('round', Number(total_vat-total_novat), -2).toFixed(2));*/
            return total_vat; 
        },
        totalImporteLinea(item, abono, vat){
            /*var res = 0;
            if (abono) 
                res = ((item.precio * -item.cantidad) - ((item.precio * -item.cantidad)*(item.descuento/100))).toFixed(2);                 
             else 
                res = ((item.precio * item.cantidad) - ((item.precio * item.cantidad)*(item.descuento/100))).toFixed(2); 
            res = parseFloat(res) * parseFloat(item.qtyperuom);
            if (this.$store.state.appconfig.showVAT){
                var igic = ((parseFloat(item.prodPostingGroup)/100)*parseFloat(res)).toFixed(3);
                igic = parseFloat(igic).toFixed(2);
                res = parseFloat(res) + parseFloat(igic);            
            }
            return res.toFixed(2);
            */
            var res = 0;
            //if (abono) 
                //res = ((item.precio * -item.cantidad) - ((item.precio * -item.cantidad)*(item.descuento/100)));                 
             //else 
            res = ((item.precioUnit * item.cantidad) - ((item.precioUnit * item.cantidad)*(item.descuento/100))); 
            var tILT = item.importeILT * item.cantidad * parseFloat(item.qtyperuom);
            res = parseFloat(res) * parseFloat(item.qtyperuom);
            res += tILT;
            if (vat){
                var igic = ((parseFloat(item.prodPostingGroup)/100)*parseFloat(res));
                if (Number(igic)){
                    res = parseFloat(res) + parseFloat(igic);            
                } 
            }
            if (item.descuento == 100){
                res = 0;
            }
            //return res;
            if (abono)
                return (this.decimalAdjust('round', res, -2) * -1).toFixed(2);
            else
                return this.decimalAdjust('round', res, -2).toFixed(2);
        },
        groupLines(){
            this.groupedLines = JSON.parse(JSON.stringify(this.listitems)); 
            for (var i = 0; i < this.groupedLines.length; i++){
                if (!this.groupedLines[i].grouped){
                    this.groupedLines[i].grouped = true;
                    var no = this.groupedLines[i].No;
                    var ud = this.groupedLines[i].uom;                
                    var precio = this.groupedLines[i].precio;
                    var descuento = this.groupedLines[i].descuento;
                    this.groupedLines[i].lotesCaption = this.groupedLines[i].lote;
                    this.groupedLines[i].lote = [this.groupedLines[i].lote];
                    this.groupedLines[i].lote[0] = {lote : this.groupedLines[i].lote[0], qty : this.groupedLines[i].cantidad}
                    for (var j = 0; j < this.groupedLines.length; j++){
                        if ((i != j) && (!this.groupedLines[j].grouped) && (no == this.groupedLines[j].No) && (ud == this.groupedLines[j].uom) && (precio == this.groupedLines[j].precio) && (descuento == this.groupedLines[j].descuento)){
                            this.groupedLines[i].cantidad = parseFloat(this.groupedLines[i].cantidad) + parseFloat(this.groupedLines[j].cantidad);
                            this.groupedLines[i].lote.push({lote : this.groupedLines[j].lote, qty : this.groupedLines[j].cantidad});
                            this.groupedLines[i].lotesCaption += ', ' + this.groupedLines[j].lote;
                            this.groupedLines.splice(j,1);
                        } else {
                            //this.groupedLines[j].grouped = true;
                        }
                    }
                }
            };
            //this.groupedLines = listItemsGrouped;
        }
    },
    watch: {
        panelIndex: function() {
            var thisAux = this;
            setTimeout(function(){
                thisAux.$vuetify.goTo(thisAux.pageHeight)
            },200);
        },
        listitems(val){
            this.groupLines();
        },
        dialog (val){
            this.groupLines();
        },
        date (val) {
            this.dateFormatted = this.formatDate(this.date)
        },      
        loader () {
            const l = this.loader
            this[l] = !this[l]

            setTimeout(() => (this[l] = false), 3000)

            this.loader = null
        }    
    },
    components: {        
    },
    computed: {
        shipToAddresses:{
            get(){
                var res = [{ code: '', name: '', address: ''}];
                var custAdd = this.$store.state.customers[this.$store.state.selectedCustIndex].addresses;
                res = res.concat(custAdd);
                return res;
            },
        },
        items:{
            get(){
                return this.$store.state.items;
            },
            set(value){
                this.$store.commit('setItems',value);
            }
        },  
        dialog:{
            get(){
                return this.$store.state.dialogEditItem;
            },
            set(value){
                this.$store.state.dialogEditItem = value;
            }
        },
        dialogData:{
            get(){
                return this.$store.state.dialogData;
            },
            set(value){
                this.$store.state.dialogData = value;
            }
        },
        editedItems:{
            get(){
                return this.$store.state.editedItems;
            },
            set(value){
                this.$store.state.editedItems = value;
            }
        },
        editedIndex:{
            get(){
                return this.$store.state.editedIndex;
            },
            set(value){
                this.$store.state.editedIndex = value;
            }
        },
        sameNoItems:{
            get(){
                return this.$store.state.sameNoItems;
            },
            set(value){
                this.$store.state.sameNoItems = value;
            }
        },
        sameNoItemsBackup:{
            get(){
                return this.$store.state.sameNoItemsBackup;
            },
            set(value){
                this.$store.state.sameNoItemsBackup = value;
            }
        }    ,
        errors:{
            get(){
                return errors.first('dto');
            }
        },
        listitems: {
            get(){
                return this.$store.state.orderItems;
            },
            set(value){
                this.$store.commit('setOrderItems',value)
            }
        },
        loading:{
            get(){
                return this.$store.state.creatingOrder;
            }
        },
        nombreUsuario: {
            get() {
                return this.$store.state.usuario.nombre;
            }
        },
        notaPedido: {
            get(){
                return this.$store.state.notaPedido;
            },
            set(value){
                this.$store.commit('setNotaPedido',value)
            }
        },
        notaRepartidor: {
            get(){
                return this.$store.state.notaRepartidor;
            },
            set(value){
                this.$store.commit('setNotaRepartidor',value)
            }
        },
        pageHeight () {
            return document.body.scrollHeight
        },
        computedDateFormatted () {
            return this.formatDate(this.date)
        },
        totalImportePedido(){
            return this.totalImportePedidoMain(true).toFixed(2) + ' €' ;
        },
        totalImpuestoPedido(){
            /*var total = 0;
            var dto = 0;
            var igic = 0;
            var dto_cliente = '';
            //% Descuento cliente
            var dto_cliente = this.custDiscount();            
            
            
            var vats = [];
            for (var i = 0; i < this.listitems.length; i++){
                if (this.listitems[i].item){
                    var lineAmount = ((this.listitems[i].precio * this.listitems[i].cantidad * this.listitems[i].qtyperuom));
                    var dto_linea = ((this.listitems[i].descuento/100 * lineAmount));
                    lineAmount -= dto_linea;
                    if (vats == []){
                        vats.push({
                            tipo : this.listitems[i].prodPostingGroup,
                            bases : [lineAmount]
                        })
                    } else {
                        var tipo = this.listitems[i].prodPostingGroup;
                        var res = vats.find(vat =>{
                            return vat.tipo == tipo;
                        });
                        if (res){
                            res.bases.push(lineAmount);
                        } else {
                            vats.push({
                                tipo : this.listitems[i].prodPostingGroup,
                                bases : [lineAmount]
                            })
                        }
                    }
                }
            }
            //console.log(vats);
            var igic_total = 0;
            vats.forEach(vat => {
                var sum_bases = 0;
                vat.bases.forEach(base => {
                    sum_bases += base;
                });
                var igic_tmp = (vat.tipo/100) * sum_bases; 
                igic_total += igic_tmp;
            });
            //console.log(igic_total);
            //console.log(this.decimalAdjust('round', igic_total, -2));

            ////console.log(this.decimalAdjust('round', 1.005, -2));
            ////console.log(this.decimalAdjust('round', 2.154, -2));
            ////console.log(this.decimalAdjust('round', 2.155, -2));
            ////console.log(this.decimalAdjust('round', -7.725, -2));
            ////console.log(this.decimalAdjust('round', 7.725, -2));
            

            for (var i = 0; i < this.listitems.length; i++){
                if (this.listitems[i].item){
                    var lineAmount = parseFloat((this.listitems[i].precio * this.listitems[i].cantidad * this.listitems[i].qtyperuom).toFixed(2));
                    var dto_linea = parseFloat((this.listitems[i].descuento/100 * lineAmount).toFixed(2));
                    lineAmount -= dto_linea;
                    lineAmount -= parseFloat(dto_cliente/100*lineAmount)
                    var igic_linea = parseFloat((this.listitems[i].prodPostingGroup/100 * lineAmount).toFixed(3));                    
                    //igic_linea = parseFloat(igic_linea.toFixed(2));
                    igic += igic_linea;
                }
            }
            return igic.toFixed(2) + ' €';*/ 
            var total_vat = 0;
            var total_novat = 0;
            for (var i = 0; i < this.listitems.length; i++){
                total_vat += Number(this.totalImporteLinea(this.listitems[i],this.$store.state.tipoDocumento == 'abono',true));
                total_novat += Number(this.totalImporteLinea(this.listitems[i],this.$store.state.tipoDocumento == 'abono',false));
            }
            return this.decimalAdjust('round', Math.abs(Number(total_vat-total_novat)), -2); 
        },
        totalDescuentoPedido(){
            var total = 0;
            var dto = 0;
            for (var i = 0; i < this.listitems.length; i++){                
                if (this.listitems[i].item){
                    var lineAmount = parseFloat((this.listitems[i].precioUnit * this.listitems[i].cantidad * this.listitems[i].qtyperuom).toFixed(2));
                    total += lineAmount;
                    dto += parseFloat((this.listitems[i].descuento/100 * lineAmount).toFixed(2));
                }                    
            }
            //Descuento cliente
            var dto_cliente = this.custDiscount();            
            //if (this.$store.state.usuario.invoiceDisc != 0){
            if (dto_cliente != 0){
                dto += parseFloat((dto_cliente/100 * (total - dto)).toFixed(2));
            }
           
            return dto.toFixed(2) + ' €';
        },
        formTitle () {
            if (this.editedIndexPedido > -1)
                return this.listitems[this.editedIndexPedido].No + ' - ' + this.listitems[this.editedIndexPedido].Description;
        }
    },
    mounted(){  
        if (!this.$store.state.appconfig.showVAT){
            var res = this.headers.find(header =>{
                return header.text == '% IGIC';
            });
            if (res)
                this.headers.splice(7,1);
        }     
        if (!this.$store.state.appconfig.autoventa && !(this.$store.state.tipoDocumento == 'abono')){
            var res = this.headers.find(header =>{
                return header.text == 'Lote';
            });
            if (res)
                this.headers.splice(4,1);
        }      
        if (!this.$store.state.appconfig.allowUOMS){
            var res = this.headers.find(header =>{
                return header.text == 'UD';
            });
            if (res)
                this.headers.splice(3,1);
        };        
        this.groupLines();
    },
    updated(){
        var currentTime = new Date();
        var difference = currentTime - Date.parse(this.$store.state.usuario.lastActiveTime);
        difference = difference/60000;        
        if (difference > 30){
            this.setGlobalDialog('Tiempo de inactividad sobrepasado','Ha sido devuelto a la pagina de acceso',false);
            this.$store.commit("logout");
        } else {
            this.$store.state.usuario.lastActiveTime = new Date().toISOString();
        }
    },
    created(){
        //this.listitems = this.$store.state.orderItems.slice();
        /*for (var i = 0; i < this.listitems.length; i=i+2){
            var divider = { divider: true, inset: true };
            this.listitems.splice(i,0,divider);            
        }*/
    }
}
</script>
<style scoped>
 .noborderradius{
     border-radius: 0px !important;
 }
 .inneritemflex{
     width: 100%;
 }
 .totalesContent{
     text-align: -webkit-right;
 }
 .itemId{
     color: gray;
     font-weight: 200;
 }
 li {
    list-style-type: none;
 }
 .bold-text{
     font-weight: bold;
 }
.cardTitleGrid{
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    height: auto;
 }
 .subtitleGrid{
    padding-left: 15px;;
 }
 .titleNotas{
    font-size: small;
    color: white;
 }
 .notasPanel{
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 7px;
    
 }
 </style>